import { createContext, useEffect, useState } from "react";
import axiosInterceptor from "./axiosInterceptor";
export const Context = createContext();

export const ContactProvider = ({ children }) => {
  const [info, setInfo] = useState({});
  const [menu, setMenu] = useState([])
  const [socialIcon, setSocialIcon] = useState([])

  const fatchdata = async() => {
    const response = await axiosInterceptor.get('/info')
    if(response.status===1){ 
      setInfo(response.data.info)
      setMenu(response.data.header)
      setSocialIcon(response.data.social)
    }
  }
  useEffect(()=>{ fatchdata()},[])
  return (
    <Context.Provider value={{ info, menu, socialIcon }}>
      {children}
    </Context.Provider>
  );
};
